import { Component, OnInit, OnDestroy, inject, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsStatesService } from '../../core/services/us-states.service';
import { StateService } from '../../core/services/state.service';
import { SeoService } from '../../core/services/seo.service';
import { IDocumentContentResponse, ISection, ISeoDocument } from '../../core/models/documents.model';

@Component({
    selector: 'app-select-state',
    imports: [],
    templateUrl: './select-state.html',
    styleUrl: './select-state.scss',
})
export class SelectState implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);
    private readonly usStatesService = inject(UsStatesService);
    private readonly stateService = inject(StateService);
    private readonly seoService = inject(SeoService);

    // CMS content from the /home slug
    seoContent!: IDocumentContentResponse;
    sections: ISection[] = [];
    sectionsRows: ISection[][] = [];

    // Compute sorted states from service signal to avoid instantiating a new array on every check
    private readonly sortedStates = computed(() => {
        const states = this.usStatesService.usStates();
        return [...states].sort((a, b) => a.code.localeCompare(b.code));
    });

    get stateList() {
        return this.sortedStates();
    }

    ngOnInit() {
        this.stateService.set('select');
        // Kick off the load; since usStates is a signal, updates will be tracked natively
        this.usStatesService.loadUsStates();

        // Read resolved CMS data from the /home slug
        const data = this.route.snapshot.data['data'];
        console.log(data);
        
        if (data?.layout) {
            this.seoContent = data.layout;
            this.sections = this.seoContent?.document?.sections || [];

            // Group sections into rows (same pattern as DaynamicPages)
            let row = 0;
            let currentRow: ISection[] = [];
            const mainSections = this.sections.filter(
                (s) => !['sidebar', 'side_bar', 'side-bar'].some(t => (s.section_type || '').toLowerCase().includes(t))
            );

            mainSections.forEach((element) => {
                if (element.row_sort_order === row) {
                    currentRow.push(element);
                } else {
                    row += 1;
                    if (currentRow.length > 0) {
                        this.sectionsRows.push(currentRow);
                    }
                    currentRow = [element];
                }
            });
            if (currentRow.length > 0) {
                this.sectionsRows.push(currentRow);
            }

            // Apply SEO metadata
            const doc = this.seoContent?.document;
            if (doc) {
                const seoDoc: ISeoDocument = {
                    ...doc,
                    meta_title: doc.meta_title || '',
                    meta_description: doc.meta_description || '',
                    meta_keywords: doc.meta_keywords || '',
                };
                this.seoService.setPageSeo(seoDoc);
            }
        }
    }

    ngOnDestroy(): void {
        this.seoService.clearPageSeo();
    }
}
